<template>
    <div id="app">
        <template v-if="isNavigation">
            <navigation></navigation>
        </template>

        <loader :class="{'loader-hidden': !isLoading}"></loader>

        <notifications group="app" position="top center"/>

        <router-view></router-view>
    </div>
</template>

<script type="text/babel">
    import { LoadingState } from '@/config/loading-state';
    import Loader from '@/components/shared/Loader.vue';
    import Navigation from '@/components/expert/Navigation/Navigation.vue';
    import { isLoggedIn } from '@/util/expert/auth';

    export default {
        name: 'app',
        components: {
            Loader,
            Navigation,
        },
        data() {
            return {
                isLoading: false,
                isNavigation: isLoggedIn(),
                pageTitle: 'Future Talents Admin',
            };
        },
        watch: {
            '$route'(val) {
                this.isNavigation = isLoggedIn();
            },
        },
        methods: {},
        created() {
            LoadingState.$on('toggle', (isLoading) => {
                this.$store.commit(isLoading ? 'loader/increase' : 'loader/decrease');
                this.isLoading = !!this.$store.state.loader.counter;
            });
        },
    };
</script>

<style lang="scss" rel="stylesheet/scss">
    body {
        padding-top: 55px;
    }

    #app {
        padding-bottom: 50px;
    }
</style>
